<!-- Sticky top close bar -->
<div class="g-just-flex justify-content-end"
    style="position: sticky; top: 0; z-index: 1000; padding: 8px 8px 12px; background: var(--mat-sys-surface);">
    <button mat-stroked-button color="primary" (click)="dref?.close()">
        <mat-icon class="me-8">close</mat-icon>
        Close
    </button>
</div>

<div class="wrapper px-20 py-20 add-obs-wrapper" style="background-color: var(--mat-sys-surface);">



    @if(isAnyCategory && (observationCategory && observationCategory.value !== 'vital-signs' &&
    observationCategory.value !== 'laboratory'
    && observationCategory.value !== 'exam'
    )){
    <!-- {{isAnyCategory}}
    {{observationCategory && observationCategory.value !== 'vital-signs' &&
    observationCategory.value !== 'laboratory'
    && observationCategory.value !== 'exam'
    }} -->
    <!-- Observation Category Selection -->
    <div class="hint-title mb-10">
        Choose A Category Below To Add Observation
    </div>

    <mat-chip-listbox (change)="setObsCat($event)" class="chip-list">
        @for(option of generalObsCategory; track $index;){
        <mat-chip-option value="{{option.code}}" #err style="
        font: inherit !important; font-family: 'Nunito Sans' !important;
        padding: 0.25rem 0.25rem !important;
margin-right: 12px !important;
    border-radius: 20px;" selected="{{observationCategory && observationCategory.value == option.code }}">

            {{option.display}}
        </mat-chip-option>
        }

    </mat-chip-listbox>
    }
    @if(observationCategory.value == 'vital-signs'){
    <app-add-vitals></app-add-vitals>
    }@else if(observationCategory.value == 'exam'){
    <div class="exam-wrapper mat-mdc-card p-20">
        <div class="exam-title-subtitle py-15">
            <div class="exam-title">
                Add Physical Exam Observations
            </div>
            <div class="subtitle subtitle-text-color-2 pt-5">
                Choose type of physical exam observation to add from the suggested list or add a new one.
            </div>

        </div>
        <div class="a-form ">

            <div class="physical-exam-cat">
                <mat-chip-listbox class="chip-list gap-15" multiple="true">
                    @for(option of samplePhysicalExaminationObservations; track $index;){
                    <mat-chip-option [value]="option" #err class="me-15 mb-18" (selectionChange)="sv($event)">
                        <div class="code-display ">
                            <div class="display" style="font-weight: 500;">{{option.display | titlecase}}</div>
                            <div class="code subtitle-text-color-2">
                                <span>{{option.code}}</span>
                                <!-- <span class=" abs-pos-right"></span>
                                <span class="abs-pos-left"></span> -->
                            </div>
                        </div>
                    </mat-chip-option>
                    }
                </mat-chip-listbox>
                <div class="mat-field pt-20" style="max-width: 615px;">
                    <label>
                        <span>
                            {{'Or add a new physical exam observation' | titlecase}}
                        </span>
                        <br>
                        <span class="subtitle-text-color-2">Enter a name and click to search to get the correct loinc
                            codes</span>
                    </label>
                    <mat-form-field appearance="outline" floatLabel="always" style="display: block;
                    width: 100%;
                    margin-top: 12px;
                    ">


                        <div class="below g-just-flex"
                            (click)="searchCodeableConceptFromBackEnd(`blll`, `${ccfb.value}`)">
                            <mat-icon matSuffix class="me-10">search</mat-icon>
                            <span style="cursor: pointer; font-size: 12px;
                        z-index: 999999999;
                        ">
                                Click to search
                            </span>

                        </div>
                        <!-- {{ccfb.value}}{{'...'}} -->
                        <input matInput type="text" [matAutocomplete]="chuks" #ccfb
                            [formControl]="observationNameChosen" placeholder="Enter new physical exam observation">

                        <mat-autocomplete #chuks="matAutocomplete" [requireSelection]="true"
                            [displayWith]="displayConceptFieldDisplay">
                            @for(option of (observationCodeSelectData | async); track $index;){
                            <mat-option [value]="option">
                                <div class="ticket-like">
                                    <div class="text">
                                        {{option.display | titlecase}}
                                    </div>
                                    <div class="code">
                                        {{option.code | titlecase}}
                                    </div>
                                </div>
                            </mat-option>
                            }
                        </mat-autocomplete>

                    </mat-form-field>
                </div>
            </div>

        </div>
    </div>
    }


    @if(observationCategory.value == 'laboratory' && !serviceRequest){

    <div class="exam-wrapper mat-mdc-card">
        <div class="exam-title-subtitle p-15">
            <div class="exam-title">
                Add Laboratory Results
            </div>
            <div class="subtitle subtitle-text-color-2 pt-5">
                @if(!labFormFields){
                Choose the name of laboratory tests from the suggested list or enter a new one.
                }@else if(labFormFields){
                Fill the laboratory result form below.
                }
            </div>
        </div>
        @if(observationCategory.value == 'laboratory' && !labFormFields){
        <div class="a-form ">
            <div class="laboratory-observation">
                @if(false){
                <mat-chip-listbox class="chip-list gap-15" (change)="setLabsName($event)">
                    @for(option of sampleLaboratoryObservations; track $index;){
                    <mat-chip-option value="{{option.display}}" #err class="me-15 mb-18">
                        <div class="code-display ">
                            <div class="display" style="font-weight: 500;">{{option.display | titlecase}}</div>
                            <div class="code subtitle-text-color-2">
                                <span>{{option.code}}</span>
                            </div>
                        </div>
                    </mat-chip-option>
                    }
                </mat-chip-listbox>
                }
                <div class="mat-field pt-20" style="max-width: 615px;">
                    <label>
                        <span>
                            {{'Enter the Name of the Laboratory Test' | titlecase}}
                        </span>
                        <br>
                        <span class="subtitle-text-color-2">Enter a name and click to search to get the correct loinc
                            codes</span>
                    </label>
                    <mat-form-field appearance="outline" floatLabel="always" style="display: block;
                    width: 100%;
                    margin-top: 12px;
                    ">


                        <div class="below g-just-flex"
                            (click)="searchCodeableConceptFromBackEnd(`blll`, `${ccfb.value}`)">
                            <mat-icon matSuffix class="me-10">search</mat-icon>
                            <span style="cursor: pointer; font-size: 12px;
                        z-index: 999999999;
                        ">
                                Click to search
                            </span>

                        </div>
                        <input matInput type="text" [matAutocomplete]="chuks" #ccfb [formControl]="labsName"
                            placeholder="Name of the Laboratory Test">

                        <mat-autocomplete #chuks="matAutocomplete" [requireSelection]="true"
                            [displayWith]="displayConceptFieldDisplay">
                            @for(option of (observationCodeSelectData | async); track $index;){
                            <mat-option [value]="option">
                                <div class="ticket-like">
                                    <div class="text">
                                        {{option | splitHash:1 | titlecase}}
                                    </div>
                                    <div class="code">
                                        {{option | splitHash:0 }}
                                    </div>
                                </div>
                            </mat-option>
                            }
                        </mat-autocomplete>

                    </mat-form-field>
                </div>
            </div>

        </div>
        }
    </div>

    @if(labFormFields){
    <div class="mt-15">
        <app-dynamic-forms-v2 [formFields]="labFormFields" [formMetaData]="labFormMetaData"
            (formSubmitted)="submitLabResult($event)" [resetOnSubmit]="false">

        </app-dynamic-forms-v2>
    </div>
    }

    }
    <!-- @if(serviceRequest && observationCategory.value == 'laboratory'){ -->
    @if(serviceRequest){


    @if(labFormFields){
    <div class="mt-15">
        <app-dynamic-forms-v2 [formFields]="labFormFields" [formMetaData]="labFormMetaData"
            (formSubmitted)="submitLabResult($event)" [resetOnSubmit]="false">

        </app-dynamic-forms-v2>
    </div>
    }

    }

    @if(toPassIntoDynamicForms){
    <app-dynamic-forms-v2 [formFields]="toPassIntoDynamicForms" (formSubmitted)="postToBackend($event)"
        [formMetaData]="formMetaData">

    </app-dynamic-forms-v2>
    }
</div>



@if(examArray.controls.length > 0 && examArray.controls[0].value?.value){


<mat-card>
    <mat-card-header>
        <mat-card-title>

        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="my-18">
            @if(physicalExamForm.valid && examArray.controls.length > 0){
            <form [formGroup]="physicalExamForm" style="max-width: 700px; width: 100%;">
                <div class="g-just-flex flex-wrap justify-content-start gap-30">
                    <div class="form-array" formArrayName="examArray" style="    display: flex;
    gap: 20px;
    flex-wrap: wrap;
">


                        @for(exam of examArray.controls; track $index; let i = $index){
                        @let name = exam.get('name')?.value;
                        @let value = exam.get('value')?.value;


                        <div class="aafield" style="width: 280px; max-width: 100%; position: relative;"
                            formGroupName="{{i}}">
                            <button mat-icon-button color="warn" aria-label="Delete"
                                style="position:absolute; top:-6px; right:-6px; z-index:5;" (click)="removeExam(i)">
                                <mat-icon>close</mat-icon>
                            </button>
                            <label style="display:block; margin-bottom:4px;">
                                {{name.display??name | titlecase}}
                            </label>
                            <mat-form-field appearance="fill" style="width:100%;">
                                <textarea [attr.rows]="3" formControlName="value" matInput></textarea>
                            </mat-form-field>
                        </div>
                        }
                    </div>

                </div>
                <div class="mt-20" style="text-align: right;">
                    <button mat-flat-button color="primary" [disabled]="!physicalExamForm.valid"
                        (click)="onSubmitPhysicalExamForm()">
                        Save Physical Exam Observations
                    </button>
                </div>
            </form>
            }
        </div>
    </mat-card-content>
</mat-card>

}

<!-- <pre>{{logger | json}}</pre> -->